<script>
  import { pop } from 'svelte-spa-router';
</script>

<div class="min-h-screen bg-gray-50 dark:bg-gray-950 py-12 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8 border border-gray-200 dark:border-gray-700">
    <div class="mb-8 flex items-center justify-between">
      <h1 class="text-3xl font-bold text-gray-900 dark:text-gray-100">Privacy Policy</h1>
      <button 
        on:click={() => window.history.back()} 
        class="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium"
      >
        &larr; Back
      </button>
    </div>

    <div class="prose dark:prose-invert max-w-none text-gray-600 dark:text-gray-300">
      <p>Last updated: December 18, 2025</p>

      <h2>1. Information We Collect</h2>
      <p>We collect information you provide directly to us, such as when you create an account, update your profile, or communicate with us. This may include your name, email address, and other contact details.</p>

      <h2>2. How We Use Your Information</h2>
      <p>We use the information we collect to operate, maintain, and improve our services, to communicate with you, and to personalize your experience.</p>

      <h2>3. Information Sharing</h2>
      <p>We do not share your personal information with third parties except as described in this policy or with your consent. We may share information with service providers who perform services on our behalf.</p>

      <h2>4. Data Security</h2>
      <p>We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration and destruction.</p>

      <h2>5. Cookies</h2>
      <p>We use cookies and similar technologies to collect information about your activity, browser, and device.</p>

      <h2>6. Changes to this Policy</h2>
      <p>We may change this Privacy Policy from time to time. If we make changes, we will notify you by revising the date at the top of the policy.</p>

      <h2>7. Contact Us</h2>
      <p>If you have any questions about this Privacy Policy, please contact us.</p>
    </div>

    <div class="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700">
        <a href="#/" class="text-indigo-600 hover:text-indigo-500 dark:text-indigo-400 dark:hover:text-indigo-300 font-medium">Return to Home</a>
     </div>
  </div>
</div>
